import {
  getRequest,
  putRequest,
  downloadWithSavePicker,
} from "~/apis/requests/useApiCall";
import { CallHistory, CallStatus, CallType, Customer } from "~/types";
import { Pagination } from "~/types/pagination";

import { TableDataWithPagination } from "~/types/generics/tableDataWithPagination";

export const useCallHistoriesStore = definePiniaStore("callHistoriesStore", {
  state: () => ({
    _tableData: [] as Array<CallHistory>,
    _loading: false,
    _filterData: {} as Partial<CallHistory>,
    _pagination: {} as Pagination,
    _statuses: [] as Array<CallStatus>,
    _callTypes: [] as Array<CallType>,
    selectedHistoryForEdit: {} as CallHistory,
    showAudioModal: false,
    multipleSelection: [],
    showMergeModal: false,
    showEditModal: false,
    showExcScenariosModal: false,
    showLogTimeModal: false,
    showTicketsFiltersModal: false,
  }),
  actions: {
    toggleHistoriesFiltersModal() {
      this.showTicketsFiltersModal = !this.showTicketsFiltersModal;
    },
    openExcScenarioModal() {
      this.showExcScenariosModal = true;
    },
    openLogTimeModal() {
      this.showLogTimeModal = true;
    },
    closeExcScenarioModal() {
      this.showExcScenariosModal = false;
    },
    closeLogTimeModal() {
      this.showLogTimeModal = false;
    },
    openMergeModal() {
      this.showMergeModal = true;
    },
    closeMergeModal() {
      this.showMergeModal = false;
    },
    selectionChange(arr: any) {
      this.multipleSelection = arr;
    },
    setFilterData(filterData: object) {
      this._filterData = filterData;
    },
    setEditModalVisibility(val: boolean) {
      this.showEditModal = val;
    },
    setAudioModalVisibility(val: boolean) {
      this.showAudioModal = val;
    },
    setSelectedHistoryForEdit(history: CallHistory) {
      this.selectedHistoryForEdit = history;
    },

    async getCallHistories(pageNo = 1, sortBy = "id", ascending = false) {
      this._loading = true;
      const sortDir = ascending ? "asc" : "desc";
      let url = `cc/agent-call-histories?page=${pageNo}&sort_column=${sortBy}&dir=${sortDir}`;
      for (const [key, value] of Object.entries(this._filterData)) {
        if (!value) continue;
        url += `&${key}=${value}`;
      }

      const { response, error } = await getRequest<
        TableDataWithPagination<CallHistory>
      >(url);
      if (!error) {
        const { data, ...pagination } = response.data;
        this.$state._tableData = data;
        this.$state._pagination = pagination;
      }
      this._loading = false;
    },

    async updateHistory(data: { remarks: string }) {
      const { response, error } = await putRequest<CallHistory>(
        `cc/agent-call-histories/${this.selectedHistoryForEdit.id}`,
        data,
      );
      if (!error) {
        return response.data;
      }
      return null;
    },

    async getStatuses() {
      const { response, error } = await getRequest<CallStatus[]>(
        "cc/call-histories-status-list",
      );
      if (!error) {
        this.$state._statuses = response.data;
      }
    },

    async getCallTypes() {
      const { response, error } = await getRequest<CallType[]>(
        "cc/call-type-list",
      );
      if (!error) {
        this.$state._callTypes = response.data;
      }
    },
    async exportTable() {
      const sortDir = this._filterData.dir || "asc";
      const sortBy = this._filterData.sort_column || "id";
      let url = `cc/agent-call-histories/export?sort_column=${sortBy}&dir=${sortDir}`;

      for (const [key, value] of Object.entries(this._filterData)) {
        if (!value) continue;
        url += `&${key}=${value}`;
      }

      const fileName = `call_histories_export_${new Date().toISOString()}.xlsx`;

      await downloadWithSavePicker(url, fileName);
    },

    // mutations and functions
  },
  getters: {
    showEditOptions(state) {
      return state.multipleSelection.length > 0;
    },
    tableData: (state) => state._tableData,
    statuses: (state) => {
      return state._statuses;
    },
    types: (state) => state._callTypes,
    pagination: (state) => state._pagination,
    filterData: (state) => state._filterData,
  },
});
